
import React from 'react';

export const ProcessSection: React.FC = () => {
  const steps = [
    {
      number: '01',
      title: 'Diagnóstico Inicial',
      description: 'Entender negócio e necessidades',
      details: 'Reunião para conhecer sua empresa, analisar a situação atual e identificar oportunidades de melhoria na gestão contábil e tributária.'
    },
    {
      number: '02',
      title: 'Proposta Personalizada',
      description: 'Serviços e valores transparentes',
      details: 'Elaboramos uma proposta customizada com os serviços necessários, prazos e valores claros, sem surpresas ou custos ocultos.'
    },
    {
      number: '03',
      title: 'Migração ou Abertura',
      description: 'Transição ou constituição ágil',
      details: 'Cuidamos de todo o processo de migração da contabilidade atual ou abertura de nova empresa de forma rápida e segura.'
    },
    {
      number: '04',
      title: 'Gestão Contínua',
      description: 'Acompanhamento mensal e suporte',
      details: 'Atendimento contínuo com relatórios mensais, alertas de prazos e suporte sempre que precisar para o crescimento do seu negócio.'
    }
  ];

  return (
    <section className="py-20 bg-[#F8F9FA]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h3 className="text-4xl font-bold text-[#1A3A52] mb-6 font-['Playfair_Display']">
            Como Funciona
          </h3>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Um processo simples e transparente para começar a trabalhar conosco
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              {/* Connection line */}
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-16 left-full w-full h-0.5 bg-[#00A896]/30 z-0"></div>
              )}
              
              <div className="relative bg-white rounded-xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 z-10">
                <div className="w-16 h-16 bg-[#00A896] rounded-full flex items-center justify-center mx-auto mb-6">
                  <span className="text-white font-bold text-lg">{step.number}</span>
                </div>
                
                <h4 className="text-xl font-semibold text-[#1A3A52] mb-3 text-center">
                  {step.title}
                </h4>
                
                <p className="text-[#00A896] font-medium mb-4 text-center">
                  {step.description}
                </p>
                
                <p className="text-gray-600 text-sm leading-relaxed text-center">
                  {step.details}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-16">
          <div className="bg-white rounded-xl p-8 shadow-lg max-w-4xl mx-auto">
            <h4 className="text-2xl font-bold text-[#1A3A52] mb-4">
              Pronto para Começar?
            </h4>
            <p className="text-gray-600 mb-6">
              Entre em contato conosco e descubra como podemos ajudar sua empresa a crescer com uma gestão contábil estratégica.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button 
                onClick={() => window.open('tel:+554132257788', '_self')}
                className="bg-[#1A3A52] hover:bg-[#0F2A3A] text-white px-6 py-3 rounded-lg font-semibold transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-phone-line mr-2"></i>
                (41) 3225-7788
              </button>
              <button 
                onClick={() => window.open('https://wa.me/5541996543210', '_blank')}
                className="bg-[#25D366] hover:bg-[#20B858] text-white px-6 py-3 rounded-lg font-semibold transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-whatsapp-line mr-2"></i>
                WhatsApp
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
